"use strict";

exports.__esModule = true;
exports.DeviceScreenToolbar = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _core = require("@blueprintjs/core");
var _Core = require("../../Core");
var _reactCsv = require("react-csv");
var _DeviceListContext = require("../DeviceListContext");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Devices toolbar with filtering
 */
var DeviceScreenToolbar = exports.DeviceScreenToolbar = /*#__PURE__*/function (_Component) {
  function DeviceScreenToolbar() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(DeviceScreenToolbar, _Component);
  var _proto = DeviceScreenToolbar.prototype;
  _proto.onCSVExport = function onCSVExport() {
    var result = [["Device Name", "Device UUID", "Group", "Device Status", "Historical dataitems", "Realtime dataitems", "Producing State Classification", "Default Classification for Current Cycle"]];
    var devices = this.props.devices;
    devices.forEach(function (device) {
      result.push([device.name, device.uuid, device.tags, device.enabled ? "Enabled" : "Disabled", device.performanceParameters.historicalDataItems.map(function (item) {
        return item.name;
      }), device.performanceParameters.realtimeDataItems.map(function (item) {
        return item.name;
      }), device.allowProducing ? "Y" : "N", device.currentCycleClassify === "ENTIRE" ? "Entire" : "From Now"]);
    });
    return result;
  };
  _proto.render = function render() {
    var _this$props = this.props,
      count = _this$props.count,
      searchTerm = _this$props.searchTerm,
      onChange = _this$props.onChange,
      enabledFilterOn = _this$props.enabledFilterOn,
      onChangeEnabledToggle = _this$props.onChangeEnabledToggle;
    return /*#__PURE__*/_react["default"].createElement(_Core.Toolbar, null, /*#__PURE__*/_react["default"].createElement(_core.ControlGroup, null, /*#__PURE__*/_react["default"].createElement(_Core.SearchInput, {
      value: searchTerm,
      onChange: onChange
    }), /*#__PURE__*/_react["default"].createElement(_core.ButtonGroup, {
      minimal: true,
      style: {
        marginLeft: "1rem"
      }
    }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      type: "button",
      active: enabledFilterOn,
      text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "enabled",
        defaultMessage: "Enabled"
      }),
      onClick: function onClick() {
        return onChangeEnabledToggle(true);
      }
    }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
      type: "button",
      active: !enabledFilterOn,
      text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "disabled",
        defaultMessage: "Disabled"
      }),
      onClick: function onClick() {
        return onChangeEnabledToggle(false);
      }
    })), /*#__PURE__*/_react["default"].createElement(_Core.ToolbarDescription, null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "DevicesToolbar.count",
      defaultMessage: "\n              {value} {count, plural,\n                one {device}\n                other {devices}\n              }\n            ",
      values: {
        value: /*#__PURE__*/_react["default"].createElement("strong", null, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedNumber, {
          value: count
        })),
        count: count
      }
    })), /*#__PURE__*/_react["default"].createElement(_reactCsv.CSVLink, {
      data: this.onCSVExport(),
      filename: "devices.csv"
    }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      type: "button",
      icon: "download",
      style: {
        marginLeft: "10px"
      }
    }, "Download"))));
  };
  return DeviceScreenToolbar;
}(_react.Component);
DeviceScreenToolbar.defaultProps = {
  translator: undefined,
  count: 0,
  searchTerm: "",
  enabledFilterOn: true,
  devices: []
};